import { render, staticRenderFns } from "./crew-expreimburs.vue?vue&type=template&id=2c5afd00"
import script from "./crew-expreimburs.vue?vue&type=script&lang=js"
export * from "./crew-expreimburs.vue?vue&type=script&lang=js"
import style0 from "./crew-expreimburs.vue?vue&type=style&index=0&id=2c5afd00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports